import React from "react";
import SoftphoneScreenDemo from "./SoftphoneScreenDemo";
import InfoPopupModal from "../../components/infoPopupModal";
import { Platform, View } from "react-native";
import { useTranslation } from "react-i18next";
import { redirectToDeepLink } from "../../js/deeplink";
import { CustomModal } from "../../components/customModal";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useDispatch } from "react-redux";
import { setShowSoftphone } from "../../Redux/Reducers/softphoneReducer";
import CustomModal_Right from "../../components/customModal/customModal_Right";
import CustomPressable from "../../components/customPressable/customPressable";
import { ImageComp } from "../../components/Image/Image";
import { CROSS } from "../../assets";



export const SoftphoneApp = React.memo(() => {

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();


    const handleCloseModal = () => {
        dispatch(setShowSoftphone(false));
    }


    return (
        <CustomModal_Right customInnerCompsStyle={getStyles(['widgetModalContainer', 'softphoneModalContainer'])} onRequestClose={handleCloseModal}>
            <View style={getStyles(['widgetModalRootContainer', 'softphoneRootContainer'])} id="widgetModalRootContainer">
                {/* <HeaderWithBack handleCustomBackPress={handleCloseModal} handleCustomCancelClick={handleCloseModal} /> */}
                {/* <CustomPressable
                    onPress={handleCloseModal}
                    style={getStyles(['softphoneRootCrossContainer'])}
                    id={`softphoneRootCrossContainer`}
                >
                    <ImageComp source={CROSS} style={getStyles(["softphoneRootCrossImageContainer"])} id={`widgetInfoModalCloseBtnImg_landscape`} />
                </CustomPressable> */}

                {/* <SoftphoneScreenDemo /> */}

                <InfoPopupModal
                    title={t('featureNotAvailable_web.heading')}
                    subtitle={t('featureNotAvailable_web.sub_heading')}
                    onContinue={() => { redirectToDeepLink(); handleCloseModal(); }}
                    primaryBtnLabel={t('featureNotAvailable_web.primary_button')}
                    onClose={handleCloseModal}
                    secondaryBtnLabel={t('featureNotAvailable_web.secondary_button')}
                    OnRequestClose={handleCloseModal}
                />
            </View>
        </CustomModal_Right>
    )
});